<template>
  <section>
    <div
      v-if="investment.length > 0"
      class="grid-auto-rows grid gap-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4"
    >
      <!-- <div
        class="relative overflow-hidden"
        :class="item.type == 'PORTFOLIO' ? 'row-span-2' : 'row-span-1'"
        v-for="item in investment"
        :key="item.investment_id"
      > -->
      <div class="relative row-span-1 overflow-hidden" v-for="item in investment" :key="item.investment_id">
        <!-- IN DEVELOPMENT: REFACTORED CARD -->
        <investment-card-component :data="item" />

        <!-- OLD CARD -->
        <!-- <card-strategy
          v-else
          class="card-investment h-full"
          :item="item"
          @toggleSwitch="toggleSwitch"
        /> -->
        <!-- <card-strategy
          v-if="['STRATEGY', 'SIGNAL', 'PORTFOLIO'].includes(item.type)"
          class="card-investment h-full"
          :item="item"
          @toggleSwitch="toggleSwitch"
        /> -->

        <div
          content="Este investimento ainda <br/>não foi inicializado"
          v-tippy="{ arrow: true, theme: 'green' }"
          v-if="
            item.masks_list && item.masks_list.some((mask) => mask.type === 'FIRST_PLAY') && item.status != 'RUNNING'
          "
          class="bg-ontick-blue-600 absolute top-3 -left-5 z-10 w-20 -rotate-45 transform cursor-default text-center text-xs font-bold uppercase text-white shadow-sm"
        >
          Novo
        </div>
      </div>
      <card-new
        key="new"
        class="row-span-1"
        v-if="investment.length > 0 && investment.some((item) => item.status == 'RUNNING')"
      />
      <card-new-investment class="row-span-1" key="new-invest" v-if="investment.length == 0" />
    </div>
    <div
      v-if="loading_strategy"
      class="2x:grid-cols-4 grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4"
    >
      <placeholder v-for="item in 8" :key="item" />
    </div>
  </section>
</template>

<script>
export default {
  components: {
    CardStrategy: () => import("./card-strategy/card-strategy.component.vue"),
    CardMask: () => import("../card-investment/card-mask/card-mask.component.vue"),
    CardNew: () => import("../card-investment/card-info/card.new.component.vue"),
    CardNewInvestment: () => import("../card-investment/card-info/card.init.component.vue"),
    Placeholder: () => import("../../../../../shared/components/placeholder/placeholder-card.component.vue"),

    InvestmentCardComponent: () => import("../new-investment-card/investment-card.component.vue"),
  },

  props: {
    investment: {
      type: [Array, Object],
      default: function () {
        return [];
      },
    },
    loading_strategy: { type: Boolean, default: false },
  },

  methods: {
    toggleSwitch({ investmentId, investmentStatus, toggle }) {
      if (!toggle) {
        this.$emit("electronicSignature", { investmentId, investmentStatus });
      }
    },
    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.card-investment {
  @apply border-ontick-steel-300 dark:bg-ontick-graphite-500 relative w-full overflow-hidden rounded-lg border-2 bg-gray-50 shadow dark:border-none;
}

.activity_sign {
  @apply relative inline-flex h-2.5  w-2.5 rounded-full;
}

.transition-card {
  @apply transform transition duration-150;
}
.company {
  &-move {
    transition: all 600ms ease-in-out 50ms;
  }
  &-enter-active {
    transition: all 300ms ease-out;
  }

  &-leave-active {
    transition: all 500ms ease-in-out;
    position: absolute;
    z-index: 50;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
  &-enter {
    transform: scale(0.9);
  }
}
</style>
